<template>
  <div>
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <v-container
        v-if="!loading && item.title"
        class="py-10 py-md-13 py-lg-16 px-md-6 item"
      >
        <v-row class="mx-md-n6" justify="center" align="center">
          <v-col
            v-if="item.img && !mobile"
            class="mb-n10 mb-md-n13 mb-lg-n16 px-md-6"
            sm="5"
            md="5"
            lg="4"
          >
            <img
              class="d-block item-img"
              :src="files + item.img"
              :alt="item.title"
              height="100%"
              width="100%"
            />
          </v-col>

          <v-col class="px-md-6" cols="12" sm="7" md="6">
            <TitleWidget :align="mobile ? 'center' : 'left'">
              {{ item.title }}
            </TitleWidget>

            <img
              v-if="item.img && mobile"
              class="d-block mx-auto mt-8 item-img"
              :src="files + item.img"
              :alt="item.title"
              height="100%"
              width="50%"
            />

            <div
              v-if="item.introduction"
              class="gret--text text--darken-2 text-body-1 mt-6 ck-content"
              v-html="item.introduction"
            ></div>

            <v-dialog content-class="dialog-video" max-width="960px">
              <template v-slot:activator="{ on }">
                <ButtonWidget
                  v-if="item.introduction && item.text"
                  v-on="on"
                  class="mt-6"
                  :align="mobile ? 'center' : 'left'"
                >
                  Saiba Mais
                </ButtonWidget>
              </template>

              <template v-slot:default="dialog">
                <v-card class="py-6 px-4 px-sm-6 position-relative">
                  <div class="model-close">
                    <v-btn
                      @click="dialog.value = false"
                      color="grey darken-3"
                      width="38px"
                      height="38px"
                      depressed
                      fab
                    >
                      <v-icon color="white" size="20"> fa-times </v-icon>
                    </v-btn>
                  </div>

                  <TitleWidget>{{ item.title }}</TitleWidget>

                  <img
                    class="d-block mx-auto mt-6"
                    :src="files + item.img"
                    :alt="item.title"
                    width="40%"
                  />

                  <div
                    class="
                      gret--text
                      text--darken-2 text-body-1
                      mt-6
                      ck-content
                    "
                    v-html="item.text"
                  ></div>
                </v-card>
              </template>
            </v-dialog>
          </v-col>
        </v-row>
      </v-container>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import TitleWidget from "../widgets/TitleWidget.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";

const _config = {
  mod: "about",
};

export default {
  data: () => ({
    loading: true,
  }),
  created() {
    this.$rest(_config.mod)
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
    mobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  components: {
    LoadingWidget,
    TitleWidget,
    ButtonWidget,
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-img {
    -o-object-fit: contain;
    object-fit: contain;
    -o-object-position: right bottom;
    object-position: right bottom;
  }
}
</style>
